import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.assign.js";
import _pt from "prop-types";
var _excluded = ["id", "className", "highlightType", "icon", "compact", "tag", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import classNames from 'classnames';
import DefaultPositiveIcon from '@lmig/lmds-react-icons/dist/icons/SuccessAlert';
import DefaultNegativeIcon from '@lmig/lmds-react-icons/dist/icons/ErrorAlert';
import DefaultInformativeIcon from '@lmig/lmds-react-icons/dist/icons/Info';
import DefaultCautionIcon from '@lmig/lmds-react-icons/dist/icons/Warning';
import DefaultNeutralIcon from '@lmig/lmds-react-icons/dist/icons/Coverages';
import "./badge.css";
/**
 * @see [LMDS Badge documentation and examples](https://designsystem.lmig.com/components/Badges/code)
 *
 * API:
 *
 * @implements [BadgeProps](https://designsystem.lmig.com/components/Badges/code#Badge-props)
 * @extends [HTMLDivElement](https://microsoft.github.io/PowerBI-JavaScript/interfaces/_node_modules_typedoc_node_modules_typescript_lib_lib_dom_d_.htmldivelement.html)
 */
export var Badge = function Badge(_ref) {
  var id = _ref.id,
    className = _ref.className,
    _ref$highlightType = _ref.highlightType,
    highlightType = _ref$highlightType === void 0 ? 'informative' : _ref$highlightType,
    icon = _ref.icon,
    _ref$compact = _ref.compact,
    compact = _ref$compact === void 0 ? false : _ref$compact,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? 'div' : _ref$tag,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var Tag = tag;
  var renderIcon = function renderIcon() {
    if (icon) {
      return icon;
    }
    switch (highlightType) {
      case 'negative':
        return /*#__PURE__*/React.createElement(DefaultNegativeIcon, {
          size: "16",
          title: "Error",
          color: "negative",
          "aria-hidden": false
        });
      case 'positive':
        return /*#__PURE__*/React.createElement(DefaultPositiveIcon, {
          size: "16",
          title: "Success",
          color: "positive",
          "aria-hidden": false
        });
      case 'caution':
        return /*#__PURE__*/React.createElement(DefaultCautionIcon, {
          size: "16",
          title: "Caution",
          color: "caution",
          "aria-hidden": false
        });
      case 'neutral':
        return /*#__PURE__*/React.createElement(DefaultNeutralIcon, {
          size: "16",
          title: "Neutral",
          color: "blue",
          "aria-hidden": false
        });
      case 'informative':
      default:
        return /*#__PURE__*/React.createElement(DefaultInformativeIcon, {
          size: "16",
          title: "Info",
          color: "informative",
          "aria-hidden": false
        });
    }
  };
  return /*#__PURE__*/React.createElement(Tag, _extends({
    id: id,
    className: classNames('lmig-Badge', "lmig-Badge--".concat(highlightType), {
      'lmig-Badge--compact': compact === true
    }, className)
  }, otherProps), /*#__PURE__*/React.createElement(Tag, {
    className: "lmig-Badge-background"
  }, icon !== false && /*#__PURE__*/React.createElement("span", {
    className: "lmig-Badge-icon"
  }, renderIcon()), children && /*#__PURE__*/React.createElement("span", {
    className: "lmig-Badge-content"
  }, children)));
};
Badge.propTypes = {
  /** Add an optional ID to the outermost `<element />`, where element is defined by the `tag` prop. */id: _pt.string,
  /** Add custom classes to the outermost `<element />`, where element is defined by the `tag` prop. */className: _pt.string,
  /**
     * Set the highlight type which applies the status color and renders the default icon for the status.
     * @default 'informative'
     */
  highlightType: _pt.oneOf(['informative', 'positive', 'negative', 'caution', 'neutral']),
  /**
     * Replace the default icon displayed before `children`.
     * Unless provided, the icon is mapped to the value of the `highlightType` prop.
     * When using a custom icon, consider setting `aria-hidden` to false to allow screen readers to announce icon `title`.
     * To disable icon rendering, use icon={false}.
     */
  icon: _pt.node,
  /**
     * Set compact styling.
     * @default 'false'
     */
  compact: _pt.bool,
  /** Allow output HTML tag to be specified independent from style type.
     */
  tag: _pt.oneOf(['span', 'div']),
  /**
     * Set the content inside this element: `<span class="lmig-Badge-content">`.
     */
  children: _pt.node
};